import React, { useEffect, useRef } from 'react'
import { Bar } from 'react-chartjs-2';

const ReportSpecChart = ({ chartData }) => {
    const data = {
        labels: ["GPA", "공인성적", "동아리활동", "수상실적", "리더십활동"],
        datasets: [
            {
                data: chartData,
                backgroundColor: ["rgb(31, 31, 45)", "rgb(58, 58, 81)", "rgb(80, 80, 119)", "rgb(105,105,151)", "rgb(128, 128, 187)"],
                borderWidth: 1,
                borderRadius: 10,
                barThickness: 70,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: {
                    display: false
                }
            },
            y: {
                beginAtZero: true,
                min: 0,
                max: 3,
                ticks: {
                    callback: function (value) {
                        if (value === 3) return "상"; // 최댓값
                        if (value === 2) return "중";  // 중간값
                        if (value === 1) return "하";  // 최솟값
                        return ""; // 나머지는 빈 값 처리
                    },
                },
                grid: {
                    drawTicks: false, // 눈금 제거
                    color: (context) => {
                        const value = context.tick.value;
                        return value === 3 || value === 2 || value === 1 ? "rgba(0, 0, 0, 0.2)" : "transparent";
                    },
                    lineWidth: (context) => {
                        const value = context.tick.value;
                        return value === 3 || value === 2 || value === 1 ? 1 : 0;
                    },
                },
            },
        },
        plugins: {
            legend: { display: false, position: "top" },
            title: { display: false, text: "Bar Chart Example" },
            tooltip: { enabled: false },
        },
    };

    return <Bar data={data} options={options} />;
}

export default ReportSpecChart